import React, { useState } from "react";
import { Card, CardBody, Button, Collapse } from "reactstrap";
import { ChevronDown, ChevronUp } from "lucide-react";

const CollapsibleSection = ({ title, items, children, editable, onEdit }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card className="mb-3 shadow border-lt">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0"><strong>{title}</strong></h6>
          <div className="d-flex align-items-center gap-2">
            {editable && (
              <Button
                color="dark"
                size="sm"
                className="me-2"
                onClick={onEdit}
              >
                Edit
              </Button>
            )}
            <Button className="dropdown-toggle-btn" onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </Button>
          </div>
        </div>

        <Collapse isOpen={isOpen}>
          {items && Array.isArray(items) && items.length > 0 ? (
            items.map((item, index) => (
              <p key={index}>
                <strong>{item.label}</strong>{" "}
                <span className="text-muted">{item.value}</span>
              </p>
            ))
          ) : (
            children
          )}
        </Collapse>
      </CardBody>
    </Card>
  );
};

export default CollapsibleSection;
